import { Col, Form, Input, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import { isString } from "lodash";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const KindForm: React.FC<FormType> = (props) => {
  const { form, values, data, submit } = props;
  const {
    varietyKindGroups: { nodes: varietyKindGroups },
  } = data;

  const onFinish = (values: any) => {
    const input = {
      ...values,
      kindKindGroups: values.kindKindGroups?.map((kindGroupId: any) => ({
        kindGroupId,
      })),
    };
    submit(input);
  };

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="nameIt" label="Name IT" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameEn" label="Name EN" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="kindKindGroups" label="Kind Groups">
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionLabelProp="label"
              filterOption={(input, option) => {
                let label = "";
                if (option?.label && isString(option.label)) label = option.label;
                let value = option?.value;
                return (
                  label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {varietyKindGroups.map((kindGroup: any) => (
                <Select.Option key={kindGroup.id} value={kindGroup.id} label={kindGroup.code}>
                  {kindGroup.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
